// extracted by mini-css-extract-plugin
module.exports = {"container_s":"styles_container_s__KYS_X","main":"styles_main__nDYIO","main_profile":"styles_main_profile__yNNdU"};